import '@ice-web-app/shared-i18n';
import { Toast } from '@ice-web-app/shared-ui-ssr';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
      <Toast />
    </BrowserRouter>
  </StrictMode>,
);
